import { render, staticRenderFns } from "./PartnerLocatorSearch.vue?vue&type=template&id=95b97bf2"
import script from "./PartnerLocatorSearch.vue?vue&type=script&lang=js"
export * from "./PartnerLocatorSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Label: require('/app/components/Label.vue').default})
